// extracted by mini-css-extract-plugin
export default {"sidebar":"_4eEzaUr4Crxgv+nDqyg21-dtxSkxzXyk88WuU6nVeLg="};